import React from "react";
import {PageHeading} from "peggirkit";
import {generateBreadcrumbs} from "../../../layout/Breadcrumbs";
import {Route} from "@/routing/Router";
import {FormattedMessage, useIntl} from "react-intl";
import LoyaltyRewardsHeadingActions from "@widgets/loyaltyRewards/overview/heading/LoyaltyRewardsHeadingActions";
import LocationPageMeta from "@widgets/heading/meta/LocationPageMeta";

type Props = {
    route: Route,
};

const LoyaltyRewardsHeading = ({route}: Props) => {
    const intl = useIntl();

    return (
        <div className={"flex flex-col gap-4"}>
            <PageHeading
                breadcrumbs={generateBreadcrumbs(route, intl)}
                title={intl.formatMessage(({id: "loyaltyRewards"}))}
                actionRowHorizontal={false}
                actionRow={<LoyaltyRewardsHeadingActions/>}
                meta={<LocationPageMeta/>}
                breakpoints={{md: {actionRowHorizontal: true}}}
            />

            <p className={"w-full text-sm max-w-[600px] text-gray-500 dark:text-slate-400"}>
                <FormattedMessage id={"loyaltyRewardsExplanation"}/>
            </p>
        </div>
    );
};

export default LoyaltyRewardsHeading;